import { Form, Select } from "antd";
import SelectDropdownLgIcon from "../../../../../assets/icons/SelectDropdownLgIcon";
import { selectStringOption } from "../../../../../utils/utils";
import { QuestionTypeProps } from "../_types/type";

export default function LinearScaleField({ index }: QuestionTypeProps) {
  return (
    <div className="mt-4">
      <div className="flex items-center gap-8">
        <Form.Item
          name={[index, "linear_scale_from"]}
          className="mb-0"
          initialValue={1}
        >
          <Select
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 80 }}
            options={selectStringOption(
              [...Array(5)].map((_, i) => (i + 1).toString()),
              "number",
            )}
            // className="select-border-none"
          />
        </Form.Item>
        <span className="block">to</span>
        <Form.Item
          name={[index, "linear_scale_to"]}
          className="mb-0"
          initialValue={5}
        >
          <Select
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 80 }}
            options={selectStringOption(
              [...Array(5)].map((_, i) => (i + 1).toString()),
              "number",
            )}
            // className="select-border-none"
          />
        </Form.Item>
      </div>
    </div>
  );
}
